import { render } from "./DatabaseSyncConf.vue?vue&type=template&id=6e9de78c"
import script from "./DatabaseSyncConf.vue?vue&type=script&lang=js"
export * from "./DatabaseSyncConf.vue?vue&type=script&lang=js"

import "./DatabaseSyncConf.vue?vue&type=style&index=0&id=6e9de78c&lang=css"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__